import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import SendMessage from '../message'
import router from '../router'

// 모든모듈 modules로 임포트
import * as modules from './modules/'

const getUserAgent = () => {
  const ua = navigator.userAgent.toLowerCase()
  const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua)
  return isTablet
}

// 기본 api 응답 timeout
axios.defaults.timeout = 10000
axios.interceptors.response.use(function (response) {
  // 2xx 범위에 있는 상태 코드 - 응답 데이터가 있는 작업 수행
  return response
}, function (error) {
  // 2xx 외의 범위에 있는 상태 코드 - 응답 오류가 있는 작업 수행
  const code = error.code
  const status = error.response && error.response.status
  // store.commit('loading', false)
  SendMessage(status, code)
  /**
   * code === "ECONNABORTED" || status === 408
   * timeout 발생 || 서버에서 408 에러 리턴
   */
  return Promise.reject(error)
})

// VUEX 사용처리
Vue.use(Vuex)

// VUEX 스토어 생성
const store = new Vuex.Store({
  // 전역 상태로 사용할것이 있다면 이곳에 추가
  state: {
    siteInfo: {},
    deviceOs: 'ANDROID',
    dimmed: false,
    loading: false,
    translate: '',
    translateReady: null,
    translateRestore: false, // 언어가 변한 뒤 번역 원복이 아니라 언어 변환이 감지되면 변하기 전에 번역 원복 후 언어 변환
    imgSrc: null,
    videoSrc: null,
    talkOn: false,
    talkWs: false,
    talkChannel: false,
    ua: getUserAgent() ? 'tablet' : 'other',
    routerActive: null, // 현재 활성화중인 메뉴id
    routerActiveParents: [] // 현재 활성화 메뉴의 parent ids
  },
  mutations: {
    setDeviceOs (state, os) {
      state.deviceOs = os
    },
    setActiveMenu (state, data) {
      // console.log(data)
      state.routerActive = data.id
      state.routerActiveParents = data.parentsIds || []
    },
    siteInfo (state, data) {
      state.siteInfo = data
    },
    dimmed (state, data) { // data = boolean
      state.dimmed = data
    },
    loading (state, data) { // data = boolean
      state.loading = data
    },
    translate (state, type) { // data = 'manual' || 'auto'
      state.translate = type
    },
    translateReady (state, data) {
      state.translateReady = data
    },
    translateRestore (state, data) {
      state.translateRestore = data // boolean
    },
    setImgSrc (state, src) {
      state.imgSrc = src
    },
    setVideoSrc (state, src) {
      state.videoSrc = src
    },
    talk (state, data) {
      state.talkOn = data
      if (data) {
        store.commit('talk/received', 0)
      }
    },
    talkWs (state, data) {
      state.talkWs = data
    },
    talkChannel (state, data) {
      state.talkChannel = data
    }
  },
  dispatch: {
  },
  getters: {
    translate: state => state.translate,
    translateReady: state => state.translateReady,
    translateRestore: state => state.translateRestore,
    getSiteInfo: state => state.siteInfo,
    getImgSrc: state => state.imgSrc,
    getVideoSrc: state => state.videoSrc,
    talk: state => state.talkOn,
    talkWs: state => state.talkWs,
    talkChannel: state => state.talkChannel,
    isTablet: state => state.ua === 'tablet',
    getActiveMenuId: state => state.routerActive,
    getActiveMenuParentsIds: state => state.routerActiveParents,
    getDeviceOs: state => state.deviceOs
  },
  modules: modules.default
})

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    store.commit('loading', false)
    return error
  }
)

export default store
